export const elementSourceMap = new WeakMap<
  HTMLMediaElement,
  { ctx: AudioContext; src: MediaElementAudioSourceNode }
>();

/**
 * Returns a cached MediaElementAudioSourceNode for the provided media element, or
 * creates one if it does not yet exist.
 *
 * NOTE: Browsers allow only **one** MediaElementAudioSourceNode per HTMLMediaElement.
 * Attempting to create a second node throws an `InvalidStateError`.
 *
 * By centralising the creation logic we ensure the same node is reused by
 * multiple consumers (e.g. analyser, recorder) and avoid the exception.
 */
export function getOrCreateMediaElementSource(element: HTMLMediaElement): {
  ctx: AudioContext;
  src: MediaElementAudioSourceNode;
} {
  // Check cache first
  const cached = elementSourceMap.get(element);
  if (cached) return cached;

  // Safari uses a prefixed constructor
  const AudioCtx = window.AudioContext || (window as any).webkitAudioContext;
  const ctx = new AudioCtx();
  const src = ctx.createMediaElementSource(element);

  elementSourceMap.set(element, { ctx, src });
  return { ctx, src };
}
